import React from 'react'
import { Typography } from '@material-ui/core'

const NoEstablishment: React.FC = () => {
    return <Typography>NoEstablishment</Typography>
}

export default NoEstablishment
